// extracted by mini-css-extract-plugin
export var cardWrapper = "_73-0";